import { render, staticRenderFns } from "./BetCard.vue?vue&type=template&id=4c72e671"
import script from "./BetCard.vue?vue&type=script&lang=js"
export * from "./BetCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports